import React from "react";
import { Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/pro-light-svg-icons";
import { faQuestionCircle } from "@fortawesome/pro-solid-svg-icons";
import styles from "./AccountAnalysisPage.module.scss";
import genStyles from "styles/General.module.scss";
import { JWT } from "types";

const AccountAnalysisPageNotAllowed = ({
  user,
  accountName,
  analysisName,
  message,
}: {
  user: JWT;
  accountName: string;
  analysisName: string;
  message: string | undefined;
}) => {
  let accountNameUpper = accountName.toUpperCase();
  let analysisNameUpper = analysisName.toUpperCase();

  const autoEmail = `
  mailto:support@avlino.com
  ?subject=Request%20Analysis%20Access%20on%20${window.location.hostname}
  &body=Requesting%20access%20to%20the%20following%20Analysis:%0A%0AAccount:%20${accountNameUpper}%0AAnalysis:%20${analysisNameUpper}%0A
  %0AName:%20${user.first_name}%20${user.last_name}
  %0AUsername:%20${user.username}
  %0AEmail:%20${user.email}
  %0A%0AThanks!
  %0A
  `;

  return (
    <Col style={{ width: "100%" }} className={genStyles["vertical-center"]}>
      <div className={genStyles["horizontal-center"]}>
        <div>
          <FontAwesomeIcon
            className={styles["not-allowed__icon"]}
            icon={faExclamationTriangle}
          />
        </div>
        {message ? (
          <h1 className={styles["not-allowed__header"]}>{message}</h1>
        ) : null}
        <p className={styles["not-allowed__text"]}>
          You do not have permission to access the "{analysisNameUpper}"
          Analysis in the "{accountNameUpper}" Account.
        </p>
        <p className={styles["not-allowed__text"]}>
          Contact an Administrator or Account Owner to provide access.
        </p>
        <p className={styles["not-allowed__text__help"]}>
          <FontAwesomeIcon icon={faQuestionCircle} /> Help: You will need to me
          a member of the "{accountNameUpper}" Account, then added to a Team
          that has been given viewing permissions for the "{analysisNameUpper}"
          Analysis.
        </p>
        <p className={styles["not-allowed__text__help"]}>
          <a href={autoEmail}>Contact support@avlino.com for assistance</a>.
        </p>
      </div>
    </Col>
  );
};

export default AccountAnalysisPageNotAllowed;
